import React from "react";

import PageContentLayout from "@/App/layouts/PageContent";
import PatientSearchForm from "./SearchForm";
import ResultsTable from "./ResultsTable";

const PatientSearch: React.FC = () => {
  return (
    <PageContentLayout title="Search for Patient" pageContentWrapperClassName="search-form-and-results-wrapper">
      <PatientSearchForm />
      <ResultsTable />
    </PageContentLayout>
  );
};

export default PatientSearch;
